import { render, staticRenderFns } from "./ChinaChart.vue?vue&type=template&id=20a5dce4&scoped=true"
import script from "./ChinaChart.vue?vue&type=script&lang=js"
export * from "./ChinaChart.vue?vue&type=script&lang=js"
import style0 from "./ChinaChart.vue?vue&type=style&index=0&id=20a5dce4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a5dce4",
  null
  
)

export default component.exports